import { BASE_URL } from "#next-seo.config";
import { generateNextSeo } from "next-seo/pages";
import Head from "next/head";
import Container from "~/components/Container";
import ProjectCard from "~/components/ProjectCard";

// seo
export const relativeUrl = "/work/open-source";
export const url = `${BASE_URL}${relativeUrl}`;
export const title = "Samuel Batista's Open Source Work";
export const description: string = "Free open source tools & utilities created by Samuel Batista.";

export async function getStaticProps() {
  const [portableSecret] = await Promise.all([import("./open-source/portable-secret")]);

  return {
    props: {
      portableSecret: {
        title: portableSecret.title,
        url: portableSecret.url,
        description: portableSecret.description
      }
    }
  };
}

export default function WorkOpenSource({ portableSecret }) {
  return (
    <Container>
      <Head>
        {generateNextSeo({
          title,
          canonical: url,
          openGraph: {
            url,
            title
          }
        })}
      </Head>
      <div className="flex flex-col justify-center items-start max-w-2xl mx-auto mb-16">
        <h1 className="font-bold text-3xl md:text-5xl tracking-tight mb-4 text-black dark:text-white">
          Tools & Utilities
        </h1>
        {/* <p className="text-gray-600 dark:text-gray-400 mb-4">
          Here is a collection of open sourced tools and utilities I&apos;ve created.
        </p> */}
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-1 my-2 w-full mt-4">
          <ProjectCard
            key={portableSecret.slug}
            title={portableSecret.title}
            href={portableSecret.url}
            description={portableSecret.description}
            svgIcon={
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" style={{ width: 32 }}>
                {/* <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --> */}
                <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zm40-176c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40z" />
              </svg>
            }
          />
        </div>
      </div>
    </Container>
  );
}
